import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { container } from 'tsyringe';
import { ChatService } from '../../../services/chat-service';

import DOMPurify from "dompurify";

import { getBadgeColor, getInitials, useSharedState } from '../../../utils/helpers';
import { WebRTCsdkService } from '../../../services/webrtcsdk-service';
import { MeetingConnectionState } from '../../../models/meetingClass';

import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'
import { ReactComponent as StudioSvg } from '../../../assets/icons/studio-logo.svg';
import * as R from 'ramda';

import "./PublicChatTool.scss";
import { MpSharp } from '@mui/icons-material';
import { FullChatMessage } from '../../../models/ptChat';
import { first } from 'lodash';
import { checkText } from 'smile2emoji'
import { UserService } from '../../../services/user-service';
import RetryAfter from './RetryAfter';

/* ChatMessage
body: "333"
event: {guid: '6f3a1468-52d6-4019-95d5-8b658bb09801'}
id: "06bf1e29df2147468fd505118bd3f973"
moderatorChat: true
moderatorPresenterChat: false
privateChat: false
sender: {guid: 'e2291758-cc4d-43fc-8718-33e86257cb2a', name: 'windows 2', role: 'moderator', userId: '4913571'}
tag: "moderator"
timestamp: 1639054361461
[[Prototype]]: Object
*/




export interface LogoProp {
  sender: any;
  isSelf: boolean;
}
export const Logo = (props: LogoProp) => {
  const {sender} = props;
  // if (sender && sender.name) {
  //   sender.name = 'studio';
  // }
  const name = sender?.name || 'Studio';
  const firstname = sender?.firstname || '';
  const lastname = sender?.lastname || '';
  const fullname = firstname + lastname;
  const initials = fullname.length > 0 ?  getInitials(fullname) :  getInitials(name);
  const bgcolor = fullname.length > 0 ?  getBadgeColor(fullname) :  getBadgeColor(name);

  const [userService] = useState(container.resolve(UserService));
  const profilePictureUrl = 'url(' + userService.profilePicture + ')';

  return (
    <>
    { name === "Studio" ?
    <StudioSvg className="publicchattool-msg-logo"></StudioSvg>
    :
    ( props.isSelf && profilePictureUrl ?
    <div className="publicchattool-msg-picture" style={{backgroundImage: profilePictureUrl}}></div>
    :
    <div className="publicchattool-msg-initials" style={{backgroundColor: bgcolor}}>{initials}</div>
    )
    }
    </>
  )
}

export interface ChatMsgProp {
  msg: any;
  isSelf: boolean;
  toggleOnStream: any;
  onDeleteClicked: any;
}
export const PublicChatMsg = (props: ChatMsgProp) => {

  const { msg, isSelf, toggleOnStream, onDeleteClicked } = props;

  return (
    <>
      <div className="publicchattool-msg-container">
      <div className={"publicchattool-msg-rectangle " + (msg.onStreamDate ? 'publicchattool-msg-rectangle-on-stream' : '')} onClick={() => toggleOnStream(msg)}>
      { msg.id !== "12345678" ?
          <div className={"publicchattool-msg-wrapper " + (msg.onStreamDate ? 'publicchattool-msg-wrapper-on-stream' : '')}>
            <div className="publicchattool-msg-header">
              <Logo sender={msg?.sender} isSelf={msg?.isSelf}></Logo>
              <div className="publicchattool-msg-sender">{msg?.sender?.name}</div>
              <div className="publicchattool-msg-date">{msg?.date}</div>
            </div>
            <div className="publicchattool-msg-body">{msg.body}</div>
          </div>
        :
          <div className="publicchattool-msg-first">
            <div className="publicchattool-msg-header">
              <Logo sender={msg?.sender} isSelf={false}></Logo>
              <div className="publicchattool-msg-sender">{msg?.sender?.name}</div>
              <div className="publicchattool-msg-date">{msg?.date}</div>
            </div>
            <div className="publicchattool-msg-body">{msg.body}</div>
          </div>
        }
        </div>
        { msg.id !== "12345678" &&
          !msg.onStreamDate &&
          !isSelf  &&
          <div className="publicchattool-msg-trash" onClick={() => onDeleteClicked(msg)}></div>
        }
        { msg.id !== "12345678" &&
         (msg.onStreamDate ?
          <div className="publicchattool-msg-hide-from-stream">
            <div className="publicchattool-msg-hide-from-stream-info">
              Hide Chat from the Stream
            </div>
          </div>
          :
          <div className="publicchattool-msg-show-on-stream">
            <div className="publicchattool-msg-show-on-stream-info">
              Show Chat on the Stream
            </div>
          </div>
        )}
      </div>
    </>
  )

}

export const PublicChatTool = () => {

  const [chatService] = useState(container.resolve(ChatService));
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));

  // const [showDeleteHistoryDialog, setShowDeleteHistoryDialog] = useState(false);

  const [publicMsg , setPublicMsg] = useState([]);
  // const [newMessage] = useSharedState(chatService.newPublicMessage$);
  // const [deleteMessageId] = useSharedState(chatService.deletePublicMessage$);
  const [publicMessages, setPublicMessages] = useSharedState(chatService.publicChatMessages$);

  const [clearHistory, setClearHistory] = useSharedState(chatService.clearHistory$);

  const [meetingState] = useSharedState(webRTCsdkService.meetingState$);
  const [isMeetingConnected, setMeetingConnected] = useState(true);   // DEMO connected by default

  const [chatInput, setChatInput] = useState('');
  const [isEmojiVisible, setEmojiVisible] = useState(false);
  const lastMsg = useRef(null);
  const inputTextRef = useRef(null);


  const firstMsg : FullChatMessage = {
    body: "Social comments display here. Click on them to showcase on stream.",
    // event: {guid: '6f3a1468-52d6-4019-95d5-8b658bb09802'},
    id: "12345678",
    instanceId: '',
    moderatorChat: false,
    moderatorPresenterChat: false,
    privateChat: false,
    sender: {guid: 'e2291758-cc4d-43fc-8718-33e86257cb2c', name: 'Studio', role: 'moderator', userId: 4913572},
    receiver: null,
    tag: "public",
    timestamp: 1639054361481,
    isUnread: false,
    onStreamDate: 0,
    deleteDate: 0,
    isSelf: true,
  };


  const scrollToRef = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }

  const getPublicHistory = useCallback(() => {

    // get all public messages history
    const publicChatHistory = chatService.publicChatMessages$.getValue();

    if (notAlreadyDisplayed(firstMsg, publicChatHistory)) {
      publicChatHistory.unshift(firstMsg);
    }

    // reset unread counter
    chatService.resetUnreadPublicChat();

    if (publicChatHistory && publicChatHistory.length > 0) {
      const msg = [];
      publicChatHistory.map(m => {
        const date = moment.unix(m.timestamp/1000).format('LT');
        const fromNow = moment.unix(m.timestamp / 1000).fromNow();
        msg.push({ ...m, date, fromNow });
      });
      console.log('HOSTCHAT get all history', msg.length)
      setTimeout(() => {
        // give time for lastMsg elem to be diplayed at right topOffet
        scrollToRef(lastMsg);
      }, 20);
      setPublicMsg(msg);
    }
  }, [chatService]);

  useEffect(() => {
    getPublicHistory();

    // // add fake
    // const msg = [
    //   {
    //     body: "111",
    //     event: {guid: '6f3a1468-52d6-4019-95d5-8b658bb09801'},
    //     id: "06bf1e29df2147468fd505118bd3f901",
    //     moderatorChat: false,
    //     moderatorPresenterChat: false,
    //     privateChat: false,
    //     sender: {guid: 'e2291758-cc4d-43fc-8718-33e86257cb2a', name: 'Gilles 1', role: 'moderator', userId: '4913571'},
    //     tag: "public",
    //     timestamp: 1639054361461,
    //     isUnread: false,
    //     onStreamDate: 0
    //   },
    //   {
    //     body: "Nulla congue neque eu iaculis tempor. Nam tempus libero lorem, eu luctus ex blandit eget. Vivamus pellentesque tellus quam, at tristique arcu scelerisque ac. Donec justo felis, interdum pellentesque justo quis, interdum tincidunt leo. Fusce efficitur consequat arcu ac placerat. Proin vel magna condimentum, imperdiet lectus semper, laoreet tellus. Mauris efficitur massa a mauris fringilla, molestie sollicitudin purus molestie. Nunc pharetra, mi cursus cursus gravida, nisi nunc maximus nunc, et vulputate nisl enim a erat. Curabitur accumsan tincidunt massa vel rhoncus.",
    //     event: {guid: '6f3a1468-52d6-4019-95d5-8b658bb09802'},
    //     id: "06bf1e29df2147468fd505118bd3f902",
    //     moderatorChat: false,
    //     moderatorPresenterChat: false,
    //     privateChat: false,
    //     sender: {guid: 'e2291758-cc4d-43fc-8718-33e86257cb2b', name: 'Hector Rapace', role: 'moderator', userId: '4913572'},
    //     tag: "public",
    //     timestamp: 1639054361471,
    //     isUnread: false,
    //     onStreamDate: 0
    //   },
    //   {
    //     body: "Welcome to the PS5 event of the year!!!",
    //     event: {guid: '6f3a1468-52d6-4019-95d5-8b658bb09804'},
    //     id: "06bf1e29df2147468fd505118bd3f904",
    //     moderatorChat: false,
    //     moderatorPresenterChat: false,
    //     privateChat: false,
    //     sender: {guid: 'e2291758-cc4d-43fc-8718-33e86257cb2c', name: 'Studio', role: 'moderator', userId: '4913572'},
    //     tag: "public",
    //     timestamp: 1639054361491,
    //     isUnread: false,
    //     onStreamDate: 0
    //   },

    // ];

    // setPublicMessages(msg);


  }, [publicMessages]);


  const notAlreadyDisplayed = (message, list):boolean => {
    for (const msg of list) {
      if (msg.timestamp === message.timestamp &&
        msg.body === message.body &&
        msg.sender.guid === message.sender.guid) {
        return false;
      }
    }
    return true;
  };

  // useEffect(() => {
  //   // a new public message is received
  //   if (newMessage) {

  //     if (notAlreadyDisplayed(newMessage, publicMsg)) {
  //       const date = moment.unix(newMessage.timestamp/1000).format('LT');
  //       const fromNow = moment.unix(m.timestamp / 1000).fromNow();
  //       msg.push({ ...m, date, fromNow });
  //       console.log('HOSTCHAT get new message')
  //       setPublicMsg([...publicMsg, message]);
  //       setTimeout(() => {
  //         // give time for lastMsg elem to be diplayed at right topOffet
  //         scrollToRef(lastMsg);
  //       }, 20);

  //     }
  //     // reset unread counter
  //     chatService.resetUnreadPublicChat();

  //   }
  // }, [newMessage]);

  // useEffect(() => {
  //   if (deleteMessageId) {
  //     const publicMsgR = R.clone(publicMsg);
  //     const deleted = publicMsgR.find(m => m.id === deleteMessageId);
  //     if (deleted) {
  //       // console.log('DELETE chat found', deleted)
  //       deleted.isDeleted = true;
  //       setPublicMsg(publicMsgR);
  //       setTimeout(() => {
  //         setPublicMsg(publicMsgR.filter(m => m.id !== deleteMessageId));
  //       }, 2000);
  //     }
  //   }
  // }, [deleteMessageId]);

  useEffect(() => {
    // all public messages have been cleared
    if (clearHistory) {
      console.log('HOSTCHAT clear history');
      setPublicMsg([]);
      // reset unread counter
      chatService.resetUnreadPublicChat();
    }
  }, [clearHistory]);

  useEffect(() => {
    console.log('HOSTCHAT', meetingState);
    if (meetingState) {
      const isConnected = meetingState.connexionState === MeetingConnectionState.CONNECTED;
      if (isConnected  && !isMeetingConnected) {
        // reset unread counter
        chatService.resetUnreadPublicChat();

        // wasn't connected => get history
        setTimeout(() => {
          getPublicHistory();
        }, 2000);
      }
      setMeetingConnected(true);
    }
  }, [meetingState])

  const handleInputChange = useCallback(
    event => {
      // sanitize the input a little
      const text = event.target.value;
      const withemoji = checkText(text);
      setChatInput(DOMPurify.sanitize(withemoji.substring(0, 500)));
  }, [setChatInput]);

  const inputKeyPressed = useCallback((e) => {
    if (e.code === 'Enter') {
      onEnter();
    }
  }, [chatInput]);

  const addEmoji = useCallback((e) => {
    // console.log('add emoji', e);
    setChatInput(DOMPurify.sanitize((chatInput + ' ' + e.native).substring(0,500)));
    setEmojiVisible(false);
    if (inputTextRef && inputTextRef.current) {
      inputTextRef.current.focus();
    }
  }, [chatInput])

  const onEnter = useCallback(() => {
    chatService.sendChatMessage(chatInput, "public");
    setChatInput('');
  }, [chatInput]);


  const toggleOnStream = (toggledMsg) => {

    if (toggledMsg.id === firstMsg.id) return;

    // find msg in messages
    const publicMsgR = R.clone(publicMsg);
    const msg = publicMsgR.find(m => m.id === toggledMsg.id);
    if (msg) {
      if (msg.onStreamDate > 0) {
        msg.onStreamDate = 0;
      } else {
        // reset all onStream
        publicMsgR.forEach(m => m.onStreamDate = 0);
        msg.onStreamDate = Date.now();
      }

      setPublicMsg(publicMsgR);
      // write public chat status into service
      setPublicMessages(publicMsgR);
    }
  }

  const onDeleteClicked = async (deletedMsg) => {
    // find msg in messages

    if (deletedMsg.id === firstMsg.id) return;

    const msg = publicMsg.find(m => m.id === deletedMsg.id);
    if (msg) {
      chatService.deleteMsg(deletedMsg.id);
    }
  }

  return (
    <>
    { isMeetingConnected ?
      <>
      <div className="publicchattool-wrapper">
      <ul>
        {
        publicMsg.map( m =>
          <li key={m.id}>
            { m.deleteDate ?
              <div className="publicchattool-msg-deleted">Message has been deleted</div>
              :
              <PublicChatMsg msg={m} toggleOnStream={(msg)=> toggleOnStream(msg)} onDeleteClicked={onDeleteClicked} isSelf={m.isSelf}></PublicChatMsg>
            }
          </li>
        )
        }
        <li ref={lastMsg} id="ghost for scrollIntoView"></li>
      </ul>
      </div>

      <div className='publicchattool-footer'>

        <div className='input-rectangle'>
          <RetryAfter>
            <>
            <input id="publicchattool-input" type="text" placeholder="Start chatting with everyone in the event…" className="publicchattool-input" value={chatInput} onChange={handleInputChange} onKeyPress={e => inputKeyPressed(e)} ref={inputTextRef}/>
            <div className='emoji-selector' onClick={() => setEmojiVisible(!isEmojiVisible)}></div>
            </>
          </RetryAfter>
        </div>
        {/*  may be one day ;) - delete all visible chat
        <div className="delete-history" onClick={() => setShowDeleteHistoryDialog(true)}></div>
        */}

        { isEmojiVisible &&
            <div className='emoji-picker'>
              <Picker onSelect={addEmoji} native={true} showPreview={true} showSkinTones={true} emojiTooltip={true} />
            </div>
        }
      </div>
      </>

    :

      <>
        Waiting for the Meeting to be connected.
      </>
    }

    </>
  )
}